export default "<p>logisticdashboard works!</p>\n"